/**
 * Created by rhinov15 on 26/10/2016.
 */

import { EntityNode } from "./EntityNode";
import { AreaNode } from "../Nodes/AreaNode";
import { GameObjectManager } from "../GameObjectManager";
import { Area, ComponentConstants, Events, eventsManager, math, WorkTop } from "@rhinov/savane-js";

declare var cc: any;

export class WorkTopNode extends EntityNode {

    //@const
    _INSIDE_COLOR = cc.color(120, 230, 120, 125);
    //@const
    _INSIDE_HOVERED_COLOR = cc.color(160, 255, 160, 125);
    //@const
    _INSIDE_SELECTED_COLOR = cc.color(230, 230, 120, 125);
    //@const
    _BORDER_COLOR = new cc.color(120, 120, 120, 255);
    //@const
    _LEG_COLOR = new cc.color(90, 90, 90, 255);
    _CREDENCE_COLOR = new cc.color(60, 60, 60, 255);

    override savaneEntity: WorkTop;

    constructor(entity: WorkTop) {
        super(entity);
        this.savaneEntity = entity;
        //Create subarea node
        var area = entity.getComponent(ComponentConstants.ComponentType.Area) as Area;
        if (area !== null) {
            this.areaNode = new AreaNode(area, area.vertices, this._INSIDE_COLOR, this._BORDER_COLOR);
            this.areaNode.setName("AreaWorktop" + entity.id);
            this.addChild(this.areaNode);
        } else {
            this.areaNode = null;
        }

        this._lineSelected = null;
        this._closed = true;
        this._technicalMode = false;
    }

    removeArea () {
        this.areaNode.removeFromParent();
        this.areaNode = null;
    }
    createArea (area: Area) {
        if (this.areaNode !== null) {
            console.log("Area already exist");
            return;
        }
        this.areaNode = new AreaNode(area, area.vertices, this._INSIDE_COLOR, this._BORDER_COLOR);
        this.addChild(this.areaNode);
    }
    isClosed (): boolean {
        return this._closed;
    }
    setClosed (value: boolean) {
        this._closed = value;
        this.areaNode.setClosed(value);
    }
    setSelected (value: boolean) {
        super.setSelected(value);
        if (this.areaNode !== null) {
            this.areaNode.setColor(value ? this._INSIDE_SELECTED_COLOR : this._INSIDE_COLOR);
            this.areaNode.setPointVisible(value);
            this.areaNode.setDimensionsVisible(value);
        }
    }
    setHovered (value: boolean) {
        super.setHovered(value);
        if (this.areaNode !== null && !this.isSelected()) {
            this.areaNode.setColor(value ? this._INSIDE_HOVERED_COLOR : this._INSIDE_COLOR);
        }
    }
    setPointSelected(_value: boolean) {
    }
    setLineSelected(_value: boolean) {
    }
    update (dt: number) {
        super.update(dt);
        //Visibility depend on state
        //this.setVisible(this._technicalMode);
        if (this.isVisible()) {
            this.areaNode.draw();
            this.clear();
            var legs = this.savaneEntity.legs;
            var credences = this.savaneEntity.credences;

            for (var j = 0; j < legs.length; j++) {
                var beg = math.vec3.clone(legs[j].begin);
                var end = math.vec3.clone(legs[j].end);

                beg[0] -= this.savaneEntity.transform.globalPosition[0];
                beg[1] -= this.savaneEntity.transform.globalPosition[1];
                beg[2] -= this.savaneEntity.transform.globalPosition[2];
                end[0] -= this.savaneEntity.transform.globalPosition[0];
                end[1] -= this.savaneEntity.transform.globalPosition[1];
                end[2] -= this.savaneEntity.transform.globalPosition[2];

                this.drawSegment(GameObjectManager.convertToCocosCoord(beg), GameObjectManager.convertToCocosCoord(end), 4, this._LEG_COLOR);
            }

            for (var j = 0; j < credences.length; j++) {
                var beg = math.vec3.clone(credences[j].begin);
                var end = math.vec3.clone(credences[j].end);

                beg[0] -= this.savaneEntity.transform.globalPosition[0];
                beg[1] -= this.savaneEntity.transform.globalPosition[1];
                beg[2] -= this.savaneEntity.transform.globalPosition[2];
                end[0] -= this.savaneEntity.transform.globalPosition[0];
                end[1] -= this.savaneEntity.transform.globalPosition[1];
                end[2] -= this.savaneEntity.transform.globalPosition[2];
                this.drawSegment(GameObjectManager.convertToCocosCoord(beg), GameObjectManager.convertToCocosCoord(end), 4, this._CREDENCE_COLOR);
            }
        }
    }
    /**
     *  Register event on enter
     **/
    onEnter () {
        super.onEnter();
        //Listener for hover enter
        this._addAreaListener = eventsManager.instance.addListener(Events.COMPONENT_REMOVED,
            (event: any) => {
                var component = event.userData.component;
                var parent = event.userData.from;
                if (parent !== null && parent !== undefined && parent.id === this.savaneEntity.id &&
                    component !== null && component !== undefined &&
                    component.componentType === ComponentConstants.ComponentType.Area) {
                    this.removeArea();
                }
            });
        this._removeAreaListener = eventsManager.instance.addListener(Events.COMPONENT_ADDED,
            (event: any) => {
                var component = event.userData;
                if (component !== null && component !== undefined &&
                    component.entity !== null && component.entity !== undefined &&
                    component.entity.id === this.savaneEntity.id &&
                    component.componentType === ComponentConstants.ComponentType.Area) {
                    this.createArea(component);
                }
            });
        this._editedAreaListener = eventsManager.instance.addListener(Events.COMPONENT_EDITED,
            (event: any) => {
                var component = event.userData;
                if (this.areaNode && component && component.entity &&
                    component.entity.id === this.savaneEntity.id &&
                    component.componentType === ComponentConstants.ComponentType.Area) {
                    //Update vertices and drawing
                    this.areaNode.setVertices(component.vertices);
                }
            });
        this._technicalPlanListener = eventsManager.instance.addListener(Events.TOGGLE_TECHNICAL_WORKTOP, (event: any) => {
            var value = event.userData;
            this._technicalMode = value;
            if (this.areaNode !== null) {
                this.areaNode.setPointVisible(value);
                this.areaNode.setDimensionsVisible(value);

            }
            //Force an update
            this.update(0);
        });
        this._worktopLineSelectionListener = eventsManager.instance.addListener(Events.SELECT_AREA_LINE, (event: any) => {
            var datas = event.userData;
            if (this.areaNode && datas.area !== null && datas.area !== undefined && datas.area.entity === this.savaneEntity) {
                this.areaNode.setLineSelected(datas.line);
            }
        });
        this._worktopPointSelectionListener = eventsManager.instance.addListener(Events.SELECT_AREA_POINT, (event: any) => {
            var datas = event.userData;
            if (this.areaNode && datas.area !== null && datas.area !== undefined && datas.area.entity === this.savaneEntity) {
                this.areaNode.setPointSelected(datas.point);
            }
        });

    }
    onExit () {
        super.onExit();
        eventsManager.instance.removeListener(this._addAreaListener);
        eventsManager.instance.removeListener(this._removeAreaListener);
        eventsManager.instance.removeListener(this._editedAreaListener);
        eventsManager.instance.removeListener(this._worktopLineSelectionListener);
        eventsManager.instance.removeListener(this._worktopPointSelectionListener);
        eventsManager.instance.removeListener(this._technicalPlanListener);
    }
}
